import React, { useEffect } from 'react';
import { useHistory, Redirect, useLocation } from 'react-router-dom';
import { useSession, usePrevious } from '@cordata/buffet';
import Helmet from 'react-helmet';
import { find, forEach, kebabCase, values, upperCase } from 'lodash';
import { useTranslation } from 'react-i18next';

import { RouteTeller } from '~/components';
import {
  routes,
  authorizedPyInstance as py,
  authorizedInstance as rb,
  authorizedInstanceNoBase as full,
} from '~/utils';

const Paths = () => {
  const { isAuthed, current } = useSession();
  const location = useLocation();
  const history = useHistory();
  const [, i18n] = useTranslation();
  const prevLocationPathname = usePrevious(location.pathname);

  const userInPrivateRoutes = () =>
    location.pathname !== '/' &&
      location.pathname !== '/hwc' &&
      !location.pathname.startsWith('/cit') &&
      !location.pathname.includes('login') &&
      !location.pathname.startsWith('/ext');

  useEffect(() => {
    const element = document.getElementById('root');

    if (current) {
      const themeClasses = [find(current.attributes.accessibleDivisions, ['divisionUid', current.attributes.currentDivisionUid]).divisionName];

      py
        .get(`api/data/public/division/${current.attributes.currentDivisionUid}`)
        .then(({ data: { data: { relationships } } }) =>
          full
            .get(relationships.org.related))
        .then(({ data: { data: r } }) => {
          themeClasses.push(r.attributes.orgName);

          forEach(themeClasses, t =>
            element.classList.add(`t-${kebabCase(t)}`));

          if (r.attributes.marketUid) {
            py
              .get(`api/data/reference/reference-market/${r.attributes.marketUid}`)

              .then(({ data: { data: m } }) => {
                element.classList.add(`t-${kebabCase(m.attributes.marketName)}`);
              });
          }
        });
    } else if (!isAuthed && userInPrivateRoutes()) {
      history.push('/');
    }
  }, [current]);

  useEffect(() => {
    const element = document.getElementById('root');

    element.classList.remove(`p-${kebabCase(prevLocationPathname)}`);
    element.classList.add(`p-${kebabCase(location.pathname)}`);
  }, [location]);

  useEffect(() => {
    if (isAuthed) {
      rb
        .get('translations')
        .then(r => r.data)
        .then(r => {
          if (r) {
            const [l, d] = kebabCase(Object.keys(r)[0]).split('-');

            if (l && d) {
              i18n.addResourceBundle(l, upperCase(d), values(r)[0]);

              i18n.setDefaultNamespace(upperCase(d));
            }
          }
        });
    }
  }, [isAuthed]);

  return (
    <React.Fragment>
      <Helmet
        titleTemplate="%s - Navigator - Cordata"
      />

      {window.location.pathname === '/' && isAuthed && (<Redirect to="/home" />)}
      {window.location.pathname === '/' && !isAuthed && (<Redirect to="/login" />)}

      <RouteTeller
        routes={routes}
        root
      />
    </React.Fragment>
  );
};

export default Paths;
